export enum SellingMode {
  SINGLE_ITEM = "SINGLE_ITEM",
  UNIT_BASED = "UNIT_BASED",
  MEASURED = "MEASURED"
}
